import React from 'react';

export default function ColorNavbar(props) {
    return (
        <div className="balance d-flex">
            <div className="text-flame"><strong>{props.symbol}</strong>{' - ' + props.amount}</div>
        </div>
    )
}